import i18n from "../../core/i18n";
import { formatUiDate } from "./dateFormat";

/**
 * Formats a date+time with a locale-aware connector word ("at" / "o" / "v").
 * The date part follows the UI language's natural order (shared/utils/dateFormat.ts —
 * USER-LANG-DATE-ORDER-1); the time stays 24 h.
 *
 * @param date   - ISO string or Date object
 * @param includeDay - whether to include abbreviated weekday name (e.g. "Tue")
 * @returns formatted string like "Mar 3, 2025 at 14:37" (en) / "3 mar 2025 alle 14:37" (it),
 *          or "Tue, Mar 3, 2025 at 14:37" with the weekday
 */
export const formatDateTimeAt = (date: string | Date, includeDay = false): string => {
  const connector = i18n.t("common:dateTimeConnector");
  const datePart = formatUiDate(date, includeDay ? "weekdayDate" : "date");
  return `${datePart} ${connector} ${formatUiDate(date, "time")}`;
};
